$(window).ready( function () {
    var url=(window.location.href).replace('/view/', '/l/');
    url=url.split("?")[0];
    $.get(url, function (data) {
        //job done
    });
});
